import {
  Component,
  Inject,
  OnInit,
  Renderer2,
  ChangeDetectionStrategy
} from '@angular/core';
import { UtilsService } from '../../../shared/utils.service';
import { AppService } from '../../../app.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FolderModel } from '../../../shared/folder.model';
import { RBACService } from '../../../shared/rbac.service';
import { Router } from '@angular/router';
import { DocumentPermissions } from '../../../interfaces/document-permissions.interface';

@Component({
  selector: 'app-account-docs-layout',
  templateUrl: './account-docs-layout.component.html',
  styleUrls: ['./account-docs-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AccountDocsLayoutComponent implements OnInit {
  folder_id: number;
  folder: FolderModel;
  is_training_doc: boolean = false;

  // Used to determine which list of document types to show.
  show_document_types_list_for: 'account' | 'user' = 'account';
  // Used to either show or hide the document visibility field.
  show_document_visibility: boolean;

  // Permissions configuration passed from parent component
  permissions: DocumentPermissions;

  constructor(
    public utils: UtilsService,
    public app: AppService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public renderer: Renderer2,
    private rbac: RBACService,
    private dialogRef: MatDialogRef<AccountDocsLayoutComponent>,
    private router: Router
  ) {}

  ngOnInit() {
    this.folder_id = this.dialogData.folder.id;
    this.folder = this.dialogData.folder;
    this.is_training_doc = this.dialogData.is_training_doc;
    // Store which list of document types to show.
    this.show_document_types_list_for = this.dialogData.show_document_types_list_for;
    // Store whether to show the document visibility or not.
    this.show_document_visibility =
      this.dialogData.show_document_visibility || false;

    // Get permissions from dialog data with default fallback
    this.permissions = this.dialogData.permissions || {
      feature: '',
      canCreate: false,
      canEdit: false,
      canDelete: false
    };

    // Check permissions - if editing existing document, user needs edit permission
    if (this.folder_id && !this.permissions.canEdit) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to edit this document.'
      );
      this.dialogRef.close();
      return;
    }

    // If creating new document, user needs create permission
    if (!this.folder_id && !this.permissions.canCreate) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to create documents.'
      );
      this.dialogRef.close();
      return;
    }
  }
}
